var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDCar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 10.882,
    viewBox: "0 0 20 10.882",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    transform: "translate(-806.375 -602.956)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    d: "M821.456,638.422a1.784,1.784,0,1,0,1.784,1.784A1.786,1.786,0,0,0,821.456,638.422Zm0,2.743a.959.959,0,1,1,.959-.959A.96.96,0,0,1,821.456,641.165Z",
    transform: "translate(-10.555 -28.152)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    d: "M878.026,638.422a1.784,1.784,0,1,0,1.784,1.784A1.786,1.786,0,0,0,878.026,638.422Zm0,2.743a.959.959,0,1,1,.959-.959A.96.96,0,0,1,878.026,641.165Z",
    transform: "translate(-55.459 -28.152)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    d: "M825.668,608.031a9.189,9.189,0,0,0-3.337-1.28s-3.2-3.706-5.186-3.706c-.792,0-5.123-.089-5.123-.089-2.172,0-5.646,1.829-5.646,5.28v2.955a1.091,1.091,0,0,0,1.091,1.091H808.5c-.007-.075-.012-.151-.012-.229a2.41,2.41,0,1,1,4.82,0c0,.077,0,.153-.011.229h6.869c-.007-.075-.011-.151-.011-.229a2.41,2.41,0,1,1,4.82,0c0,.077,0,.153-.012.229h.434a.966.966,0,0,0,.931-1.091S826.63,608.9,825.668,608.031Zm-8.128-.158a1.891,1.891,0,0,1-.213.9,1.559,1.559,0,0,1-.6.624,1.7,1.7,0,0,1-.862.228h-.909a.3.3,0,0,1-.3-.3V606.26a.3.3,0,0,1,.3-.3h.884a1.735,1.735,0,0,1,.873.22,1.55,1.55,0,0,1,.605.622,1.876,1.876,0,0,1,.22.9Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    d: "M851.134,620.842a.3.3,0,0,0-.3.3v1.709a.3.3,0,0,0,.3.3h.01a.687.687,0,0,0,.584-.271,1.327,1.327,0,0,0,.2-.8v-.158a1.316,1.316,0,0,0-.2-.8A.7.7,0,0,0,851.134,620.842Z",
    transform: "translate(-35.293 -14.198)",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDCar);
export default __webpack_public_path__ + "static/media/d-car.78a6eb36.svg";
export { ForwardRef as ReactComponent };